import React,{useEffect} from "react";
import SMSReportComp from '../Components/SMSReport/SMSReportComp';
const SMSReport = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);

    },[]);
    return (
        <div>
            <SMSReportComp />
        </div>
    )
}

export default SMSReport;